import {combineEpics} from 'web-app/util/redux-observable';

import notificationSettingsEpics from './notification-settings/epics';
import conversationSettingsEpics from './conversation-settings/epics';
import feedSettingsEpics from './feed-settings/epics';
import accountDetailsEpics from './account-details/epics';
import notificationHoursSettingsEpics from './notification-hours-settings/epics';

export default combineEpics(
    notificationHoursSettingsEpics,
    feedSettingsEpics,
    notificationSettingsEpics,
    conversationSettingsEpics,
    accountDetailsEpics,
);
